










import Vue from 'vue';
import Component from 'vue-class-component';
import Customer from '@/models/Customer';
import { getOr } from '@/utilities/helpers';

const Setup = Vue.extend({
	name: 'ReservationCustomerSummary',
	props: {
		customer: {
			type: Object,
			required: true,
		},
	},
});

@Component
export default class ReservationCustomerSummary extends Setup {
	// Props
	public customer!: Customer;

	public get loggedInCustomer(): Customer {
		return this.$store.getters.customer;
	}

	public get customersMatch(): boolean {
		return this.loggedInCustomer.customer > 0
			&& this.loggedInCustomer.customer === this.customer.customer;
	}
}
